import SEO from './SEO';
import { buildUrl } from '../../config/seo';

const ThankYouSEO = () => {
  return (
    <SEO
      title="Thank You - The Web Dev Interview"
      description="Thank you for contacting The Web Dev Interview. We'll get back to you soon."
      url={buildUrl('/thank-you')}
      type="website"
    />
  );
};

export default ThankYouSEO;